import React from 'react'
import {useState, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { startWindow, showWindow, hideWindow, focusWindow, fullScreen, closeWindow, showStartMenu, hideStartMenu } from '../slices/mwSelectSlice';
import Draggable from "react-draggable";
import Background from '../img/emocat.jpg';
import TaskButton from './TaskButton';

const TaskBar = () => {
    const tBarX = document.body.clientWidth
    const font = '"Terminal ", monospace'
    let time = new Date().toLocaleTimeString();
    const [hoverState, setHover] = useState(false) 
    const [currentTime, changeTime] = useState(time);
    const [showStart, setShowStart] = useState(false)
    const windowCheck = useSelector((state) => state.shower.window);
    const taskListCHeck = useSelector((state) => state.shower.taskList);
    const startMenuVis = useSelector((state) => state.shower.startMenu);
    const dispatch = useDispatch()
    const aboutMeLogo = require('../img/about_moi64.jpg')
    const projectsLogo = require('../img/projects_64.jpg')
    const resumeLogo = require('../img/resume_64-nbg.png')
    const contactLogo = require('../img/contact_64.png')
    const canvasLogo = require('../img/hamster.png')
    const dogLogo = require('../img/dog.png')
    const webcamLogo = require('../img/webcam.png')

    const checkTime = () => {
      time = new Date().toLocaleTimeString();
      changeTime(time);
    }

    setInterval(checkTime, 1000);

    const setHoverTrue = () => {
      setHover(true)
    }
    
    const setHoverFalse = () => {
      setHover(false)
    }

    const setMenu = (id) => {
      if(id === 'about-me-window'){
        return aboutMeLogo
      }else if(id === 'projects-window'){
        return projectsLogo
      }else if(id === 'resume-window'){
        return resumeLogo
      }else if(id === 'contact-window'){
        return contactLogo
      }else if(id === 'canvas-window'){
        return canvasLogo
      }else if(id === 'vis-window'){
        return dogLogo
      }else if(id === 'webcam-window'){
        return webcamLogo
      }
    }


    const startMenuClick = () => {
        if(!startMenuVis){
          dispatch(showStartMenu())
        }else if(startMenuVis){
          dispatch(hideStartMenu())
        }
        //console.log(startMenuVis)
    }
  
    //console.log(windowCheck.find((w) => w.windowID === task).title)
    return(
        <div style={{display: 'flex', zIndex: '10000' , width: '100%', height: '5%', backgroundColor:'rgb(76, 201, 240)', position: 'fixed', top: '95%', }}>
            <div className='startButtonDiv' style={{ width: window.innerWidth*.0265, height: '100%', backgroundImage: `url(${Background})`, backgroundSize: '100%', backgroundRepeat: 'no-repeat'}}>
                <button className='startButton' onClick={startMenuClick} onMouseEnter={setHoverTrue} onMouseLeave={setHoverFalse} 
                style={{width: '100%',
                height: '100%',
                backgroundColor: hoverState ? 'rgba(255, 255, 255, 0.2)':'transparent',
                border: 'none',
                cursor: 'pointer',}}>
                </button>
            </div>
          {
            
            taskListCHeck.map((task) => <TaskButton key={task}
            taskTitle={windowCheck.find((w) => w.windowID === task).title} 
            mwType={task} 
            taskIconURL={setMenu(task)}
            leftMargin={window.innerWidth*.0265*2 + (window.innerWidth*.0265*2+15)*taskListCHeck.indexOf(task)}></TaskButton>)
          }
          <div className='clockTaskBar' style={{
            zIndex: '10001',
            width: window.innerWidth*.03*2, 
            position: 'absolute',
            height: '75%',
            outline: 'medium inset  rgb(76, 201, 240)',
            outlineOffset: '-5px',
            padding: '5px',
            alignSelf: 'center',
            borderRadius: '10px', 
            marginLeft: '93%',
            backgroundColor: 'rgba(255,255,255,0.2)', 
            fontFamily: font,
            //alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}>
            <p style={{
              fontFamily: font,
              //verticalAlign: 'center',
              alignSelf: 'center',
              textAlign: 'center',
            }}>
              {currentTime}
            </p>
          </div>
        </div>
    )

}

export default TaskBar